module.exports = __webpack_public_path__ + "static/media/Close.5b0475e4.png";